import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DropzoneVideo from "../../components/dropzone/DropzoneVideo";
import Multiselect from "multiselect-react-dropdown";

const AddEditQuestions = ({
  type,
  stories = [],
  question = {},
  activeStory = {},
}) => {
  const [video, setVideo] = useState(null);
  const [locations, setLocations] = useState([]);
  //   console.log("locations", locations);

  const onSelectStory = (selectedList, selectedItem) => {
    var ids = selectedList.map((item) => item._id);
    setLocations(ids);
  };

  const onRemoveStory = (selectedList, removedItem) => {
    var ids = selectedList.map((item) => item._id);
    setLocations(ids);
  };

  const selectedStory = stories.filter(
    (story) => story.id === activeStory?._id
  );

  const handleAddQuestion = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("video", video);
      formData.append("stories", locations);

      const response = null;

      if (response) {
        try {
          toast.success("Add question successfully !");
          // Close the upload modal
          // const modalInstance = bootstrap.Modal.getInstance(
          //   uploadModalRef.current
          // );
          // modalInstance.hide();
          window.location.reload();
        } catch (error) {
          window.location.reload();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleEditQuestion = async (event) => {
    console.log("EDIT QUESTIONS");

    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("stories", locations.concat(activeStory?._id));
      formData.append("questionId", question._id);

      const response = null;

      if (response) {
        toast.success("Updated Question Successfully!");
        window.location.reload();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      <form onSubmit={type == "add" ? handleAddQuestion : handleEditQuestion}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {type == "add" ? "Add Questions" : " Edit Questions"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="recipient-name" className="col-form-label">
                  Title
                </label>
                <input
                  defaultValue={question?.title}
                  type="text"
                  className="form-control truncate"
                  id="recipient-name"
                  placeholder="Title"
                  name="title"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="recipient-name" className="col-form-label">
                  Select Stories
                </label>
                <Multiselect
                  options={stories} // Options to display in the dropdown
                  selectedValues={selectedStory} // Preselected value to persist in dropdown
                  onSelect={onSelectStory} // Function will trigger on select event
                  onRemove={onRemoveStory} // Function will trigger on remove event
                  displayValue="title" // Property name to display in the dropdown options
                />
              </div>
              {/* <div className="mb-3">
                        <label for="recipient-name" className="col-form-label">
                          Thumbnail
                        </label>

                        <DropzoneThumbnail
                          onFileUpload={setThumbnail}
                          accept={{
                            "image/*": [],
                          }}
                          title="thumbnail"
                        />
                      </div> */}
              <div className="mb-3">
                <label htmlFor="recipient-name" className="col-form-label">
                  Question Video
                </label>
                <DropzoneVideo
                  onVideoSelect={setVideo}
                  accept={{
                    "video/*": [],
                  }}
                  title="Question Video"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                id="add-question"
                type="submit"
                className="btn-model"
                data-bs-target="#exampleModalToggle2"
                data-bs-toggle="modal"
              >
                {type == "add" ? " Add question" : "Edit question"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddEditQuestions;
